import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })


export class InventarioService {


    backendUrl: string = environment.apiUrl;
    url_final: string;


    constructor(private http: HttpClient) {
    }

    cambiarBackOrder(item_id, set_back_order){
      this.url_final = this.backendUrl + "/rmsfe/set_back_order_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { item_id, set_back_order})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarBundle(item_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_bundle?item_id="
      this.url_final = `${this.url_final}${item_id}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    getEtiqueta(item_id, seller_sku){
      this.url_final = this.backendUrl + "/items/print_label_api?id="
      this.url_final = `${this.url_final}${item_id}&seller_sku=${seller_sku}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    cambiarBundle(entries, item_id){
      // console.log("entries en service");
     // console.log(entries);
     this.url_final = this.backendUrl + "/rmsfe/cambiar_bundle"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, item_id })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarBO(item_id){
     this.url_final = this.backendUrl + "/rmsfe/consultar_backorder?item_id="
      this.url_final = `${this.url_final}${item_id}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    surtirBO(item_id){
      this.url_final = this.backendUrl + "/rmsfe/surtir_backorder"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { item_id })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarStatusBO(item_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_status_bo?item_id="
      this.url_final = `${this.url_final}${item_id}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarAPiLiverpool(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_liverpool_key"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    actualizarApiLiverpool(api_key, api_key_guias_propias, guias_propias, id_mirakl, hacer_match_con, crear_producto_sin_match){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_liverpool_key"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { api_key, api_key_guias_propias, guias_propias, id_mirakl, hacer_match_con, crear_producto_sin_match })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarAPiMKTF(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_mktf_key"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    actualizarApiMKTF(){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_mktf_key"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarApiVentiapp(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_ventiapp_key"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        return response;
      }));
    }

    actualizarApiVentiapp(userVenti, passVenti){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_ventiapp_key"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { userVenti, passVenti })
      .pipe(map(response => {
        return response;
      }));
    }

    consultarIntegracion(){
      this.url_final = this.backendUrl + "/rmsfe/query_integrations.json"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

     crearItem(titulo, seller_sku, ean){
      this.url_final = this.backendUrl + "/rmsfe/crear_item_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { titulo, seller_sku, ean})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarPlantilla(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_plantilla_items"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    mandarEntrada(file_name){
      this.url_final = this.backendUrl + "/rmsfe/entrada_masiva_items"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { file_name })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarMasivo(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_masivo_items"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarApiOdoo(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_odoo_key"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        return response;
      }));
    }

    consultarApiElenas(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_elenas_key"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response' })
      .pipe(map(response => {
        return response;
      }));
    }

    actualizarApiOdoo(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/odoo_key"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {datos_envio})
      .pipe(map(response => {
        return response;
      }));
    }
    
    actualizarApiElenas(token, hacer_match_con){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_elenas_key"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { token, hacer_match_con })
      .pipe(map(response => {
        return response;
      }));
    }

}